const findEnumValue = <T extends string>(
  enumObj: Record<string, T>,
  valueToFind: string
): T | undefined =>
  Object.values(enumObj).find((value) => value === valueToFind);

const getBaseURL = (): string => {
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}`;
};

const compareStringsIgnoreCaseAndTrim = (
  str1: string,
  str2: string
): boolean => {
  const formattedStr1 = str1.replace(/\s/g, "").toLowerCase();
  const formattedStr2 = str2.replace(/\s/g, "").toLowerCase();
  return formattedStr1 === formattedStr2;
};


const getRandomNumber = (min: number, max: number): number => {
  const randomDecimal = Math.random();
  const randomNumberInRange = randomDecimal * (max - min) + min;
  return Math.floor(randomNumberInRange);
};

export default {
  findEnumValue,
  getBaseURL,
  compareStringsIgnoreCaseAndTrim,
  getRandomNumber
};
